import React, { useState, useRef } from 'react';
import axios from 'axios';

import ModalLoad from '../modal/ModalLoad.js';
import ModalPopupMessage from '../modal/ModalPopupMessage';

import './bee-print-billing.css';

export default function SiteReportBilling({ props, reportdata, onClose }) {
    const reportRef = useRef(null)
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })

    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function print_document(filename) {
        if (filename !== "-") {
            window.onbeforeprint = function (event) {
                document.title = filename
            };
            window.onafterprint = function (event) {
                document.title = 'Retort Advanced Batch Manager'
            };
            window.print();
            return false
        } else {
            setModal_popup({
                modaltype: 'modal-warning',
                headers: 'Warning',
                message: "No data to print!",
                enable: true
            })
        }
    }

    async function api_print_report(filename, view) {
        setmodal_load({ enable: true, message: "Generating PDF report." })
        await sleep(10)

        const reportElement = reportRef.current;
        const htmlContent = reportElement.innerHTML;
        let matchedStyles = "";

        //         // ดึง Elements ลูกทั้งหมดที่อยู่ข้างในกล่องรายงานมาเช็กด้วย
        //         const allChildElements = reportElement.querySelectorAll("*");
        //         // 2. ดึงสไตล์ CSS ทั้งหมดของหน้าเว็บไปด้วย เพื่อให้บราวเซอร์จัดหน้าได้ถูกต้อง
        //         try {
        //             for (let i = 0; i < document.styleSheets.length; i++) {
        //                 const sheet = document.styleSheets[i];
        //                 try {
        //                     for (let j = 0; j < sheet.cssRules.length; j++) {
        //                         const rule = sheet.cssRules[j];

        //                         // เช็กเฉพาะกฎที่เป็น Style Rule (ไม่ใช่อันอื่นเช่น @import หรือ @keyframes)
        //                         if (rule.type === CSSRule.STYLE_RULE) {
        //                             const selector = rule.selectorText;

        //                             // ตรวจสอบว่า Selector นี้ตรงกับกล่องหลัก หรือลูกๆ ตัวไหนด้านในไหม
        //                             const isMatchMain = reportElement.matches(selector);
        //                             let isMatchChild = false;

        //                             for (let el of allChildElements) {
        //                                 if (el.matches(selector)) {
        //                                     isMatchChild = true;
        //                                     break;
        //                                 }
        //                             }

        //                             // ถ้าตรง... ให้เก็บสไตล์ข้อนั้นไว้
        //                             if (isMatchMain || isMatchChild) {
        //                                 matchedStyles += rule.cssText + "\n";
        //                             }
        //                         } else if (rule.type === CSSRule.FONT_FACE_RULE) {
        //                             // เก็บกฎ @font-face ไว้เสมอ เพื่อให้ฟอนต์ Sarabun ทำงานได้
        //                             matchedStyles += rule.cssText + "\n";
        //                         }
        //                     }
        //                 } catch (e) {
        //                     // ข้ามอันที่ติดปัญหา Cross-Origin
        //                 }
        //             }
        //         } catch (err) {
        //             console.error("Error filtering CSS", err);
        //         }


        //         matchedStyles += `
        //   *, *::before, *::after {
        //     animation-delay: 0s !important;
        //     animation-duration: 0s !important;
        //     animation-iteration-count: 1 !important;
        //     transition-duration: 0s !important;
        //     scroll-behavior: auto !important;
        //   }
        // `;

        const allStylesText = Array.from(document.styleSheets)
            .map(sheet => {
                try {
                    return Array.from(sheet.cssRules).map(rule => rule.cssText).join("\n");
                } catch (e) {
                    // ป้องกันปัญหา Cross-Origin สำหรับ CSS ที่มาจาก CDN ด้านนอก
                    if (sheet.href) {
                        return `@import url("${sheet.href}");`;
                    }
                    return "";
                }
            })
            .join("\n");
        const formData = new FormData();
        formData.append('filename', filename)
        formData.append('style', allStylesText)
        formData.append('content', htmlContent)
        formData.append('view', view)

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/files/print/pdf", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
            responseType: 'blob'
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.status === 200) {
                    // 1. นำข้อมูลดิบมาสร้างเป็น Blob Object URL
                    const blob = new Blob([response.data], { type: 'application/pdf' });
                    const fileName = "รายงานใบอนุญาต_2026.pdf";
                    const file = new File([blob], fileName, { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);

                    // 2. เปิดไฟล์ PDF ในแท็บใหม่
                    const pdfWindow = window.open(fileURL, '_blank');
                    if (pdfWindow) {
                        pdfWindow.document.title = "รายงานใบอนุญาต_2026.pdf"; // ตั้งชื่อบนแท็บ
                    }

                } else {
                    // กรณีที่ Status ไม่ใช่ 200 (เช่น ในกรณีทั่วไป)
                    throw new Error("เกิดข้อผิดพลาดในการสร้างไฟล์");
                }
            })
            .catch(async (err) => {
                setmodal_load({ enable: false, message: "" })
                let errorMessage = err.message;

                // 💡 ทริคสำคัญ: ถ้า Echo ส่ง Error กลับมาเป็น JSON แต่เราตั้ง responseType: 'blob'
                // ตัวแปร err.response.data จะถูกแปลงเป็น Blob ด้วย เราต้องแปลงมันกลับเป็น Text เพื่ออ่าน Error Message
                if (err.response && err.response.data instanceof Blob) {
                    try {
                        const errorText = await err.response.data.text();
                        const errorJson = JSON.parse(errorText);
                        errorMessage = errorJson.message || errorMessage;
                    } catch (e) {
                        // ถ้าแปลงเป็น JSON ไม่สำเร็จ ให้ใช้ตัวหนังสือดิบๆ หรือ default error message
                    }
                }

                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: errorMessage,
                    enable: true
                });
            });
    }

    return (
        <>
            <div className='document-template-overlay'>
                <div className='document-template'>
                    <div className="d-flex justify-content-between gap-3 mt-0 mb-1 py-0 print-disable">
                        <h4 className="mb-0">Billing Preview </h4>
                        <div>
                            {/* <button className="btn btn-danger btn-sm my-0 me-2" type="button" onClick={() => { api_print_report(reportdata.file_name, 'on') }} ><i className="fa fa-pdf-file me-2"></i> Download PDF</button> */}
                            <button className="btn btn-secondary btn-sm my-0 me-2" type="button" onClick={() => { print_document(reportdata.file_name) }} ><i className="fa fa-print me-2"></i> Print Document</button>
                            <button className="btn btn-light btn-sm my-0 me-2" type="button" onClick={() => { onClose(false) }} ><i className="fe-x me-2"></i> Close</button>
                        </div>
                    </div>
                    <div className='document-template-wrapper' ref={reportRef}>
                        <div className='report-wrapper py-0 px-0'>
                            <div className="page-vertical rp-billing  mt-2">
                                <div className='billing-header'>
                                    <label className="document-header-th">ข้อมูลการใช้ไฟฟ้าระบบผลิตไฟฟ้า CPF Phase 3</label>
                                    <div className='doc-page'>1/{reportdata.total_pages}</div>
                                </div>
                                <div className="billing-table border-black-all bill-box-customer">
                                    <div className="billing-row billing-cell-group text-rightx">
                                        <b>ชื่อผู้ให้บริการ</b> <br />
                                        <b>{reportdata.service?.service_name}</b> <br />
                                        {reportdata.service?.service_address_line1} <br />
                                        {reportdata.service?.service_address_line2}
                                    </div>
                                    <div className="billing-row border-top-white">
                                        <div className="billing-cell w50">
                                            <b>ลูกค้า (Customer)</b> <br />
                                            {reportdata.info?.customer_name}<br />
                                            {reportdata.info?.customer_address}
                                        </div>
                                        <div className="billing-cell border-left-black">
                                            <b>สถานที่ใช้ไฟฟ้า (Location)</b> <br />
                                            {reportdata.info?.location_name}<br />
                                            {reportdata.info?.location_address}
                                        </div>
                                    </div>
                                </div>

                                <div className="billing-table border-black-all mt-2">
                                    <div className="billing-row ">
                                        <div className="billing-cell w166 border-bottom-black lightgrey text-centerx">
                                            <b>ขนาดติดตั้งระบบ</b>
                                        </div>
                                        <div className="billing-cell w166 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>จำนวนมิเตอร์สำหรับการเรียกเก็บค่าไฟฟ้า</b>
                                        </div>
                                        <div className="billing-cell w166 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>ประเภทผู้ใช้ไฟฟ้า</b>
                                        </div>
                                        <div className="billing-cell w166 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>วันเริ่มต้นค่าไฟฟ้า</b>
                                        </div>
                                        <div className="billing-cell w166 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>ลำดับใบแจ้งการใช้ไฟฟ้าตามสัญญา</b>
                                        </div>
                                        <div className="billing-cell w166 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>ข้อมูลการใช้ไฟฟ้าประจำเดือน</b>
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell text-centerx">
                                            {reportdata.info?.capacity}
                                        </div>
                                        <div className="billing-cell border-left-black text-centerx">
                                            {reportdata.info?.total_meter}
                                        </div>
                                        <div className="billing-cell border-left-black text-centerx">
                                            {reportdata.info?.tariff}
                                        </div>
                                        <div className="billing-cell border-left-black text-centerx">
                                            {reportdata.info?.period_start}
                                        </div>
                                        <div className="billing-cell border-left-black text-centerx">
                                            {reportdata.info?.sequence}
                                        </div>
                                        <div className="billing-cell border-left-black text-centerx">
                                            {reportdata.info?.period_month}
                                        </div>
                                    </div>
                                </div>

                                <div className="billing-table  border-black-all mt-2">
                                    <div className="billing-row">
                                        <div className="billing-cell w28 border-bottom-black lightgrey">
                                            <b>หมายเลขเครื่องวัด {reportdata.meter_1?.meter_no}</b>
                                        </div>
                                        <div className="billing-cell  border-bottom-black border-left-black text-centerx">
                                            {reportdata.meter_1?.serial_no}
                                        </div>
                                        <div className="billing-cell w28 border-bottom-black border-left-black lightgrey">
                                            <b>Type of plant</b>
                                        </div>
                                        <div className="billing-cell  border-bottom-black border-left-black text-centerx">
                                            {reportdata.meter_1?.type_of_plant}
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell w28 lightgrey">
                                            <b>เลขอ่านครั้งก่อน [Previous meter Reading]</b>
                                        </div>
                                        <div className="billing-cell border-left-black text-centerx">
                                            {reportdata.meter_1?.reading_previous}
                                        </div>
                                        <div className="billing-cell w28 border-left-black lightgrey">
                                            <b>เลขอ่านครั้งหลัง [Recent meter Reading]</b>
                                        </div>
                                        <div className="billing-cell border-left-black text-centerx">
                                            {reportdata.meter_1?.reading_recent}
                                        </div>
                                    </div>
                                </div>

                                <div className="billing-table border-black-all border-top-0">
                                    <div className="billing-row">
                                        <div className="billing-cell w12p5 border-bottom-black lightgrey">
                                            <b>รายละเอียดค่าไฟ</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>การผลิตไฟโซลาร์ (หน่วย)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>หน่วยไฟรับเข้าระบบ (หน่วย)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>หน่วยไฟสุทธิ</b>
                                        </div>
                                        <div className="billing-cell w15 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>อัตราค่าไฟ การไฟฟ้าฯ
                                                Trariff Rate (บาท)</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>ส่วนลดตามสัญญา (%)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>อัตราค่าไฟโซลาร์
                                                (บาท/หน่วย)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>จำนวนเงิน (บาท)</b>
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell border-bottom-black">
                                            <b>On Peak</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.energy_import_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.energy_export_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.energy_net_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.rate_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.discount_p_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.rate_discounted_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.total_onpeak}
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell border-bottom-black">
                                            <b>Off Peak</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.energy_import_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.energy_export_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.energy_net_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.rate_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.discount_p_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.rate_discounted_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_1?.total_offpeak}
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell">
                                            <b>Ft</b>
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_1?.energy_import_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_1?.energy_export_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_1?.energy_net_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_1?.rate_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_1?.discount_p_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_1?.rate_discounted_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_1?.total_ft}
                                        </div>
                                    </div>
                                </div>
                                <div className="billing-table border-black-all border-top-0">
                                    <div className="billing-row">
                                        <div className="billing-cell text-centerx">
                                            <b>รวมเงินค่าไฟมิเตอร์ เครื่องที่ ({reportdata.meter_1?.meter_no}) (บาท)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-left-black text-rightx">
                                            <b> {reportdata.meter_1?.total_price}</b>
                                        </div>
                                    </div>
                                </div>

                                <div className="billing-table  border-black-all mt-2">
                                    <div className="billing-row">
                                        <div className="billing-cell w28 border-bottom-black lightgrey">
                                            <b>หมายเลขเครื่องวัด {reportdata.meter_2?.meter_no}</b>
                                        </div>
                                        <div className="billing-cell  border-bottom-black border-left-black text-centerx">
                                            {reportdata.meter_2?.serial_no}
                                        </div>
                                        <div className="billing-cell w28 border-bottom-black border-left-black lightgrey">
                                            <b>Type of plant</b>
                                        </div>
                                        <div className="billing-cell  border-bottom-black border-left-black text-centerx">
                                            {reportdata.meter_2?.type_of_plant}
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell w28 lightgrey">
                                            <b>เลขอ่านครั้งก่อน [Previous meter Reading]</b>
                                        </div>
                                        <div className="billing-cell border-left-black text-centerx">
                                            {reportdata.meter_2?.reading_previous}
                                        </div>
                                        <div className="billing-cell w28 border-left-black lightgrey">
                                            <b>เลขอ่านครั้งหลัง [Recent meter Reading]</b>
                                        </div>
                                        <div className="billing-cell border-left-black text-centerx">
                                            {reportdata.meter_2?.reading_recent}
                                        </div>
                                    </div>
                                </div>

                                <div className="billing-table border-black-all border-top-0">
                                    <div className="billing-row">
                                        <div className="billing-cell w12p5 border-bottom-black lightgrey">
                                            <b>รายละเอียดค่าไฟ</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>การผลิตไฟโซลาร์ (หน่วย)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>หน่วยไฟรับเข้าระบบ (หน่วย)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>หน่วยไฟสุทธิ</b>
                                        </div>
                                        <div className="billing-cell w15 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>อัตราค่าไฟ การไฟฟ้าฯ
                                                Trariff Rate (บาท)</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>ส่วนลดตามสัญญา (%)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>อัตราค่าไฟโซลาร์
                                                (บาท/หน่วย)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>จำนวนเงิน (บาท)</b>
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell border-bottom-black">
                                            <b>On Peak</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.energy_import_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.energy_export_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.energy_net_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.rate_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.discount_p_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.rate_discounted_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.total_onpeak}
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell border-bottom-black">
                                            <b>Off Peak</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.energy_import_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.energy_export_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.energy_net_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.rate_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.discount_p_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.rate_discounted_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_2?.total_offpeak}
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell">
                                            <b>Ft</b>
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_2?.energy_import_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_2?.energy_export_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_2?.energy_net_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_2?.rate_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_2?.discount_p_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_2?.rate_discounted_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_2?.total_ft}
                                        </div>
                                    </div>
                                </div>
                                <div className="billing-table border-black-all border-top-0">
                                    <div className="billing-row">
                                        <div className="billing-cell w87p5 text-centerx">
                                            <b>รวมเงินค่าไฟมิเตอร์ เครื่องที่ ({reportdata.meter_2?.meter_no === "" ? "../.." : reportdata.meter_2?.meter_no}) (บาท)</b>
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx fw-600">
                                            {reportdata.meter_2?.total_price}
                                        </div>
                                    </div>
                                </div>

                                <div className="billing-table  border-black-all mt-2">
                                    <div className="billing-row">
                                        <div className="billing-cell w28 border-bottom-black lightgrey">
                                            <b>หมายเลขเครื่องวัด {reportdata.meter_3?.meter_no}</b>
                                        </div>
                                        <div className="billing-cell  border-bottom-black border-left-black text-centerx">
                                            {reportdata.meter_3?.serial_no}
                                        </div>
                                        <div className="billing-cell w28 border-bottom-black border-left-black lightgrey">
                                            <b>Type of plant</b>
                                        </div>
                                        <div className="billing-cell  border-bottom-black border-left-black text-centerx">
                                            {reportdata.meter_3?.type_of_plant}
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell w28 lightgrey">
                                            <b>เลขอ่านครั้งก่อน [Previous meter Reading]</b>
                                        </div>
                                        <div className="billing-cell border-left-black text-centerx">
                                            {reportdata.meter_3?.reading_previous}
                                        </div>
                                        <div className="billing-cell w28 border-left-black lightgrey">
                                            <b>เลขอ่านครั้งหลัง [Recent meter Reading]</b>
                                        </div>
                                        <div className="billing-cell border-left-black text-centerx">
                                            {reportdata.meter_3?.reading_recent}
                                        </div>
                                    </div>
                                </div>

                                <div className="billing-table border-black-all border-top-0">
                                    <div className="billing-row">
                                        <div className="billing-cell w12p5 border-bottom-black lightgrey">
                                            <b>รายละเอียดค่าไฟ</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>การผลิตไฟโซลาร์ (หน่วย)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>หน่วยไฟรับเข้าระบบ (หน่วย)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>หน่วยไฟสุทธิ</b>
                                        </div>
                                        <div className="billing-cell w15 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>อัตราค่าไฟ การไฟฟ้าฯ
                                                Trariff Rate (บาท)</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>ส่วนลดตามสัญญา (%)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>อัตราค่าไฟโซลาร์
                                                (บาท/หน่วย)</b>
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                            <b>จำนวนเงิน (บาท)</b>
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell border-bottom-black">
                                            <b>On Peak</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.energy_import_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.energy_export_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.energy_net_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.rate_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.discount_p_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.rate_discounted_onpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.total_onpeak}
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell border-bottom-black">
                                            <b>Off Peak</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.energy_import_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.energy_export_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.energy_net_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.rate_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.discount_p_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.rate_discounted_offpeak}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                            {reportdata.meter_3?.total_offpeak}
                                        </div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell">
                                            <b>Ft</b>
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_3?.energy_import_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_3?.energy_export_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_3?.energy_net_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_3?.rate_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_3?.discount_p_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_3?.rate_discounted_ft}
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx">
                                            {reportdata.meter_3?.total_ft}
                                        </div>
                                    </div>
                                </div>
                                <div className="billing-table border-black-all border-top-0">
                                    <div className="billing-row">
                                        <div className="billing-cell w87p5 text-centerx">
                                            <b>รวมเงินค่าไฟมิเตอร์ เครื่องที่ ({reportdata.meter_3?.meter_no === "" ? "../.." : reportdata.meter_3?.meter_no}) (บาท)</b>
                                        </div>
                                        <div className="billing-cell border-left-black text-rightx fw-600">
                                            {reportdata.meter_3?.total_price}
                                        </div>
                                    </div>
                                </div>

                                <div className="billing-table  border-black-all mt-2">
                                    <div className="billing-row">
                                        <div className="billing-cell w30 text-rightx border-bottom-black lightgrey">
                                            <b>รวมเงินค่าไฟมิเตอร์ เครื่องที่ ({reportdata.meter_1?.meter_no}) (บาท)</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black billing-sum">
                                            {reportdata.meter_1?.total_price}
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black billing-sum">บาท</div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell w30 text-rightx border-bottom-black lightgrey">
                                            <b>รวมเงินค่าไฟมิเตอร์ เครื่องที่ ({reportdata.meter_2?.meter_no === "" ? "../.." : reportdata.meter_2?.meter_no}) (บาท)</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black billing-sum">
                                            {reportdata.meter_2?.total_price}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black billing-sum">บาท</div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell w30 text-rightx border-bottom-black lightgrey">
                                            <b>รวมเงินค่าไฟมิเตอร์ เครื่องที่ ({reportdata.meter_3?.meter_no === "" ? "../.." : reportdata.meter_3?.meter_no}) (บาท)</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black billing-sum">
                                            {reportdata.meter_3?.total_price}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black billing-sum">บาท</div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell w30 text-rightx  lightgrey">
                                            <b>ค่าไฟฟ้าพื้นฐานตามสัญญา (บาท)</b>
                                        </div>
                                        <div className="billing-cell border-left-black billing-sum">
                                            {reportdata.summary?.base_tariff_contract}
                                        </div>
                                        <div className="billing-cell border-left-black billing-sum">บาท</div>
                                    </div>
                                </div>
                                <div className="billing-table border-black-all border-top-0">
                                    <div className="billing-row">
                                        <div className="billing-cell w30 text-rightx lightgrey">
                                            <b>ไฟฟ้าที่ส่งออกไปยังโครงข่ายการไฟฟ้า</b>
                                        </div>
                                        <div className="billing-cell border-left-black billing-sum">
                                            <div className='d-flex justify-content-between'><b>หน่วย</b>{reportdata.summary?.grid_export_energy}</div>
                                        </div>
                                        <div className="billing-cell border-left-black billing-sum">
                                            <div className='d-flex justify-content-between'><b>บาท/หน่วย</b>{reportdata.summary?.grid_export_rate}</div>
                                        </div>
                                        <div className="billing-cell border-left-black billing-sum">
                                            <div className='d-flex justify-content-between'><b>รวม</b>{reportdata.summary?.grid_export_price}</div>
                                        </div>
                                        <div className="billing-cell w12p5 border-left-black billing-sum">บาท</div>
                                    </div>
                                </div>
                                <div className="billing-table border-black-all border-top-0">
                                    <div className="billing-row">
                                        <div className="billing-cell w30 text-rightx border-bottom-black lightgrey">
                                            <b>รวมเงินค่าไฟฟ้า (บาท)</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black billing-sum">
                                            {reportdata.summary?.total_price}
                                        </div>
                                        <div className="billing-cell w12p5 border-bottom-black border-left-black billing-sum">บาท</div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell w30 text-rightx border-bottom-black lightgrey">
                                            <b>ภาษีมูลค่าเพิ่ม 7% (บาท)</b>
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black billing-sum">
                                            {reportdata.summary?.vat}
                                        </div>
                                        <div className="billing-cell border-bottom-black border-left-black billing-sum">บาท</div>
                                    </div>
                                    <div className="billing-row">
                                        <div className="billing-cell w30 text-rightx lightgrey">
                                            <b>รวมเงินทั้งสิ้น (บาท)</b>
                                        </div>
                                        <div className="billing-cell border-left-black billing-sum">
                                            {reportdata.summary?.total_amount}
                                        </div>
                                        <div className="billing-cell w12p5 border-left-black billing-sum">บาท</div>
                                    </div>
                                </div>
                                <div className='remark-box'><h6>หมายเหตุ :</h6></div>
                            </div>
                            {
                                reportdata.meter_attach?.map((data, index) => (
                                    <div className='page-vertical rp-billing mt-2'>
                                        <div className='billing-header'>
                                            <label className="document-header-th">ข้อมูลการใช้ไฟฟ้าระบบผลิตไฟฟ้า CPF Phase 3 (รายเครื่องวัด)</label>
                                            <div className='doc-page'>{index + 2}/{reportdata.total_pages}</div>
                                        </div>

                                        <div className="billing-table border-black-all bill-box-customer">
                                            <div className="billing-row billing-cell-group text-rightx">
                                                <b>ชื่อผู้ให้บริการ</b> <br />
                                                <b>{reportdata.service?.service_name}</b> <br />
                                                {reportdata.service?.service_address_line1} <br />
                                                {reportdata.service?.service_address_line2}
                                            </div>
                                            <div className="billing-row border-top-white">
                                                <div className="billing-cell w50">
                                                    <b>ลูกค้า (Customer)</b> <br />
                                                    {reportdata.info?.customer_name}<br />
                                                    {reportdata.info?.customer_address}
                                                </div>
                                                <div className="billing-cell border-left-black">
                                                    <b>สถานที่ใช้ไฟฟ้า (Location)</b> <br />
                                                    {reportdata.info?.location_name}<br />
                                                    {reportdata.info?.location_address}
                                                </div>
                                            </div>
                                        </div>


                                        <div className="billing-table border-black-all mt-2">
                                            <div className="billing-row ">
                                                <div className="billing-cell w166 border-bottom-black lightgrey text-centerx">
                                                    <b>ขนาดติดตั้งระบบ</b>
                                                </div>
                                                <div className="billing-cell w166 border-bottom-black border-left-black lightgrey text-centerx">
                                                    <b>จำนวนมิเตอร์สำหรับการเรียกเก็บค่าไฟฟ้า</b>
                                                </div>
                                                <div className="billing-cell w166 border-bottom-black border-left-black lightgrey text-centerx">
                                                    <b>ประเภทผู้ใช้ไฟฟ้า</b>
                                                </div>
                                                <div className="billing-cell w166 border-bottom-black border-left-black lightgrey text-centerx">
                                                    <b>วันเริ่มต้นค่าไฟฟ้า</b>
                                                </div>
                                                <div className="billing-cell w166 border-bottom-black border-left-black lightgrey text-centerx">
                                                    <b>ลำดับใบแจ้งการใช้ไฟฟ้าตามสัญญา</b>
                                                </div>
                                                <div className="billing-cell w166 border-bottom-black border-left-black lightgrey text-centerx">
                                                    <b>ข้อมูลการใช้ไฟฟ้าประจำเดือน</b>
                                                </div>
                                            </div>
                                            <div className="billing-row">
                                                <div className="billing-cell text-centerx">
                                                    {reportdata.info?.capacity}
                                                </div>
                                                <div className="billing-cell border-left-black text-centerx">
                                                    {reportdata.info?.total_meter}
                                                </div>
                                                <div className="billing-cell border-left-black text-centerx">
                                                    {reportdata.info?.tariff}
                                                </div>
                                                <div className="billing-cell border-left-black text-centerx">
                                                    {reportdata.info?.period_start}
                                                </div>
                                                <div className="billing-cell border-left-black text-centerx">
                                                    {reportdata.info?.sequence}
                                                </div>
                                                <div className="billing-cell border-left-black text-centerx">
                                                    {reportdata.info?.period_month}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="billing-table  border-black-all mt-2">
                                            <div className="billing-row">
                                                <div className="billing-cell w28 border-bottom-black lightgrey">
                                                    <b>หมายเลขเครื่องวัด {data.meter_data?.meter_no}</b>
                                                </div>
                                                <div className="billing-cell  border-bottom-black border-left-black text-centerx">
                                                    {data.meter_data?.serial_no}
                                                </div>
                                                <div className="billing-cell w28 border-bottom-black border-left-black lightgrey">
                                                    <b>Type of plant</b>
                                                </div>
                                                <div className="billing-cell  border-bottom-black border-left-black text-centerx">
                                                    {data.meter_data?.type_of_plant}
                                                </div>
                                            </div>
                                            <div className="billing-row">
                                                <div className="billing-cell w28 lightgrey">
                                                    <b>เลขอ่านครั้งก่อน [Previous meter Reading]</b>
                                                </div>
                                                <div className="billing-cell border-left-black text-centerx">
                                                    {data.meter_data?.reading_previous}
                                                </div>
                                                <div className="billing-cell w28 border-left-black lightgrey">
                                                    <b>เลขอ่านครั้งหลัง [Recent meter Reading]</b>
                                                </div>
                                                <div className="billing-cell border-left-black text-centerx">
                                                    {data.meter_data?.reading_recent}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="billing-table  border-black-all">
                                            <div className="billing-row">
                                                <div className="billing-cell w25 text-centerx lightgrey"><b>วันที่</b></div>
                                                <div className="billing-cell border-left-black text-centerx lightgrey"><b>Irradiation<br />
                                                    (kWh/m<sup>2</sup>)</b></div>
                                                <div className="billing-cell border-left-black text-centerx lightgrey"><b>On peak
                                                    Production (kWh)</b></div>
                                                <div className="billing-cell border-left-black text-centerx lightgrey"><b>Off peak
                                                    Production (kWh)</b></div>
                                                <div className="billing-cell border-left-black text-centerx lightgrey"><b>Total
                                                    Production (kWh)</b></div>
                                                <div className="billing-cell border-left-black text-centerx lightgrey"><b>Remark</b></div>
                                            </div>
                                            {
                                                data.table_item?.map((item, index) => (
                                                    <div className={"billing-row table-detail " + (item.date === "รวม" ? "fw-600" : "")}>
                                                        <div className="billing-cell border-top-black text-centerx ">{item.date}</div>
                                                        <div className="billing-cell border-top-black border-left-black text-centerx">{item.irr}</div>
                                                        <div className="billing-cell border-top-black border-left-black text-centerx">{item.energy_onpeak}</div>
                                                        <div className="billing-cell border-top-black border-left-black text-centerx">{item.energy_offpeak}</div>
                                                        <div className="billing-cell border-top-black border-left-black text-centerx">{item.energy_total}</div>
                                                        <div className="billing-cell border-top-black border-left-black text-centerx"></div>
                                                    </div>
                                                ))
                                            }
                                        </div>

                                        <div className="billing-table border-black-all border-top-0">
                                            <div className="billing-row">
                                                <div className="billing-cell w12p5 border-bottom-black lightgrey">
                                                    <b>รายละเอียดค่าไฟ</b>
                                                </div>
                                                <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                                    <b>การผลิตไฟโซลาร์ (หน่วย)</b>
                                                </div>
                                                <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                                    <b>หน่วยไฟรับเข้าระบบ (หน่วย)</b>
                                                </div>
                                                <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                                    <b>หน่วยไฟสุทธิ</b>
                                                </div>
                                                <div className="billing-cell w15 border-bottom-black border-left-black lightgrey text-centerx">
                                                    <b>อัตราค่าไฟ การไฟฟ้าฯ
                                                        Trariff Rate (บาท)</b>
                                                </div>
                                                <div className="billing-cell w10 border-bottom-black border-left-black lightgrey text-centerx">
                                                    <b>ส่วนลดตามสัญญา (%)</b>
                                                </div>
                                                <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                                    <b>อัตราค่าไฟโซลาร์
                                                        (บาท/หน่วย)</b>
                                                </div>
                                                <div className="billing-cell w12p5 border-bottom-black border-left-black lightgrey text-centerx">
                                                    <b>จำนวนเงิน (บาท)</b>
                                                </div>
                                            </div>
                                            <div className="billing-row">
                                                <div className="billing-cell w12p5 border-bottom-black">
                                                    <b>On Peak</b>
                                                </div>
                                                <div className="billing-cell w12p5 border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.energy_import_onpeak}
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.energy_export_onpeak}
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.energy_net_onpeak}
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.rate_onpeak}
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.discount_p_onpeak}
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.rate_discounted_onpeak}
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.total_onpeak}
                                                </div>
                                            </div>
                                            <div className="billing-row">
                                                <div className="billing-cell border-bottom-black">
                                                    <b>Off Peak</b>
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.energy_import_offpeak}
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.energy_export_offpeak}
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.energy_net_offpeak}
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.rate_offpeak}
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.discount_p_offpeak}
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.rate_discounted_offpeak}
                                                </div>
                                                <div className="billing-cell border-bottom-black border-left-black text-rightx">
                                                    {data.meter_data?.total_offpeak}
                                                </div>
                                            </div>
                                            <div className="billing-row">
                                                <div className="billing-cell">
                                                    <b>Ft</b>
                                                </div>
                                                <div className="billing-cell border-left-black text-rightx">
                                                    {data.meter_data?.energy_import_ft}
                                                </div>
                                                <div className="billing-cell border-left-black text-rightx">
                                                    {data.meter_data?.energy_export_ft}
                                                </div>
                                                <div className="billing-cell border-left-black text-rightx">
                                                    {data.meter_data?.energy_net_ft}
                                                </div>
                                                <div className="billing-cell border-left-black text-rightx">
                                                    {data.meter_data?.rate_ft}
                                                </div>
                                                <div className="billing-cell border-left-black text-rightx">
                                                    {data.meter_data?.discount_p_ft}
                                                </div>
                                                <div className="billing-cell border-left-black text-rightx">
                                                    {data.meter_data?.rate_discounted_ft}
                                                </div>
                                                <div className="billing-cell border-left-black text-rightx">
                                                    {data.meter_data?.total_ft}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="billing-table border-black-all border-top-0">
                                            <div className="billing-row">
                                                <div className="billing-cell w87p5 text-centerx">
                                                    <b>รวมเงินค่าไฟมิเตอร์ เครื่องที่ ({data.meter_data?.meter_no}) (บาท)</b>
                                                </div>
                                                <div className="billing-cell border-left-black text-rightx fw-600">
                                                    {data.meter_data?.total_price}
                                                </div>
                                            </div>
                                        </div>

                                        <div className='remark-box'><h6>หมายเหตุ :</h6></div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={msg => { PopupMsg_onGeneral(msg) }} /> : null}
        </>
    )
}
